module.exports = __webpack_public_path__ + "media/images/edscap-campanha-mob-8d3e16c7ab7fde7968efb99d8a395c0c.png";